import * as types from "../actions/actionTypes";
import {
  BEFORE_SENDING,
  FAILURE,
  PRE_SEND,
  SENDING,
  SUCCESS
} from "../constants/statusOfUploadImages";
const initialState = {
  modalStatus: false,
  mainRequestLoading: true,
  imagesRequestStatus: []
};

const UploadImage = (state = initialState, action) => {
  let imagesRequestStatusTemp = [];
  switch (action.type) {
    case types.SHOW_UPLOAD_IMAGE_MODAL:
      imagesRequestStatusTemp = Array(action.images.length).fill(
        BEFORE_SENDING
      );
      return {
        ...state,
        modalStatus: true,
        mainRequestLoading: true,
        imagesRequestStatus: imagesRequestStatusTemp
      };
    case types.HIDE_UPLOAD_IMAGE_MODAL:
      return { ...state, modalStatus: false };
    case types.UPLOAD_IMAGE_REQUEST:
      imagesRequestStatusTemp = [];
      for (let i = 0; i < action.images.length; i++) {
        let imageStatus = SENDING;
        if (action.images[i].id) {
          imageStatus = PRE_SEND;
        }
        imagesRequestStatusTemp.push(imageStatus);
      }
      return {
        ...state,
        mainRequestLoading: false,
        imagesRequestStatus: imagesRequestStatusTemp
      };
    case types.UPLOAD_IMAGE_SUCCESS:
      imagesRequestStatusTemp = [...state.imagesRequestStatus];
      imagesRequestStatusTemp[action.uploadedImageIndex] = SUCCESS;
      return { ...state, imagesRequestStatus: imagesRequestStatusTemp };
    case types.UPLOAD_IMAGE_FAILURE:
      imagesRequestStatusTemp = [...state.imagesRequestStatus];
      imagesRequestStatusTemp[action.uploadedImageIndex] = FAILURE;
      return { ...state, imagesRequestStatus: imagesRequestStatusTemp };
    default:
      return state;
  }
};

export default UploadImage;
